"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var types_1 = require("./types");
var channel_1 = require("./channel");
var connection_1 = require("./connection");
var ChatClient = /** @class */ (function () {
    function ChatClient(baseURL) {
        var _this = this;
        this.internalChannels = {};
        this.listeners = {};
        this.channels = [];
        this.wsBaseUrl = function () { return _this.baseURL.replace("http", "ws"); };
        this.connectParameters = function () {
            var _a;
            return ("token=" + _this.token +
                ("&userId=" + _this.userInfo.id) +
                ("&userName=" + _this.userInfo.name) +
                ("&userImage=" + ((_a = _this.userInfo.image) !== null && _a !== void 0 ? _a : "")));
        };
        this.baseURL = baseURL;
    }
    Object.defineProperty(ChatClient.prototype, "status", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.connection) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : types_1.ConnectionStatus.Disconnected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChatClient.prototype, "user", {
        get: function () {
            return this.userInfo;
        },
        enumerable: false,
        configurable: true
    });
    ChatClient.prototype.connectUser = function (userInfo, token) {
        this.userInfo = userInfo;
        this.token = token;
        return this.openConnection();
    };
    ChatClient.prototype.channel = function (channelType, channelId, data) {
        var _a, _b;
        if (((_a = this.connection) === null || _a === void 0 ? void 0 : _a.status) !== types_1.ConnectionStatus.Connected) {
            throw new Error("You need to connect first");
        }
        var existingChannel = null;
        if (channelId) {
            existingChannel = this.internalChannels[channelId];
        }
        else if (data.members && channelType === "private") {
            existingChannel =
                (_b = Object.values(this.internalChannels).find(function (ch) {
                    var _a, _b;
                    if (ch.channelType !== "private")
                        return false;
                    return (JSON.stringify((_a = ch.data.members) === null || _a === void 0 ? void 0 : _a.sort()) ===
                        JSON.stringify((_b = data.members) === null || _b === void 0 ? void 0 : _b.sort()));
                })) !== null && _b !== void 0 ? _b : null;
        }
        else {
            throw new Error("You need to provide a channelId, or for private channels, a list of members that includes you.");
        }
        if (existingChannel) {
            return existingChannel;
        }
        var channel = new channel_1.default(this.axiosClient, this.connection, this.userInfo, channelType, channelId, data);
        this.internalChannels[channelId] = channel;
        this.channels = Object.values(this.internalChannels);
        this.notifyListeners({ type: "newConnectedChannel", channel: channel });
        return channel;
    };
    ChatClient.prototype.queryChannels = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, channelsInfo, _b, axiosClient, connection, userInfo;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (((_a = this.connection) === null || _a === void 0 ? void 0 : _a.status) !== types_1.ConnectionStatus.Connected) {
                            throw new Error("You need to connect first");
                        }
                        return [4 /*yield*/, this.axiosClient.get("/api/channels/")];
                    case 1:
                        response = _c.sent();
                        channelsInfo = response.data;
                        _b = this, axiosClient = _b.axiosClient, connection = _b.connection, userInfo = _b.userInfo;
                        return [4 /*yield*/, Promise.all(channelsInfo.map(function (info) { return __awaiter(_this, void 0, void 0, function () {
                                var existingChannel, channel;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            existingChannel = this.internalChannels[info.id];
                                            if (existingChannel) {
                                                return [2 /*return*/, existingChannel];
                                            }
                                            channel = new channel_1.default(axiosClient, connection, userInfo, (_a = info.type) !== null && _a !== void 0 ? _a : "public", info.id, { name: info.name, members: [] }, info.messages.sort(function (a, b) { return a.date.localeCompare(b.date); }), info.lastMessageRead, info.members);
                                            return [4 /*yield*/, channel.watch(false)];
                                        case 1:
                                            _b.sent();
                                            this.internalChannels[channel.id] = channel;
                                            return [2 /*return*/, this.internalChannels];
                                    }
                                });
                            }); }))];
                    case 2:
                        _c.sent();
                        this.channels = Object.values(this.internalChannels);
                        this.notifyListeners({ type: "queriedList", channels: this.channels });
                        return [2 /*return*/, this.channels];
                }
            });
        });
    };
    ChatClient.prototype.getUnreadMessagesCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.get("/api/users/" + this.userInfo.id + "/unread/count")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.unreadCount];
                }
            });
        });
    };
    ChatClient.prototype.getUnreadMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.get("/api/users/" + this.userInfo.id + "/unread")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ChatClient.prototype.openConnection = function () {
        var _this = this;
        this.connection = new connection_1.default(this.wsBaseUrl() + "/ws?" + this.connectParameters());
        this.connection.ondown = function (error) {
            return _this.dispatchEvent({ type: "connectionDown", error: error });
        };
        this.connection.ondrop = function () {
            return _this.dispatchEvent({ type: "connectionDrop" });
        };
        this.connection.oneventmessage = function (evt) { return _this.dispatchEvent(evt); };
        this.axiosClient = axios_1.default.create({
            baseURL: this.baseURL,
            headers: {
                Authorization: this.token,
            },
        });
        return this.connection.connect();
    };
    ChatClient.prototype.closeConnection = function () {
        if (this.connection) {
            this.connection.disconnect();
            this.connection = undefined;
        }
    };
    ChatClient.prototype.on = function (eventType, handler) {
        var _this = this;
        if (this.listeners[eventType]) {
            this.listeners[eventType].push(handler);
        }
        else {
            this.listeners[eventType] = [handler];
        }
        return {
            unsubscribe: function () {
                _this.listeners[eventType] = _this.listeners[eventType].filter(function (listener) { return listener !== handler; });
            },
        };
    };
    ChatClient.prototype.off = function (eventType, handler) {
        if (this.listeners[eventType]) {
            this.listeners[eventType] = this.listeners[eventType].filter(function (listener) { return listener !== handler; });
        }
    };
    ChatClient.prototype.dispatchEvent = function (evt) {
        this.dispatchToChannels(evt);
        this.notifyListeners(evt);
    };
    ChatClient.prototype.notifyListeners = function (evt) {
        var listeners = [];
        if (this.listeners.all) {
            listeners.push.apply(listeners, this.listeners.all);
        }
        if (this.listeners[evt.type]) {
            listeners.push.apply(listeners, this.listeners[evt.type]);
        }
        listeners.forEach(function (listener) { return listener(evt); });
    };
    ChatClient.prototype.dispatchToChannels = function (evt) {
        Object.values(this.internalChannels).forEach(function (channel) {
            switch (evt.type) {
                case "connected":
                    channel.dispatchEvent(evt);
                    break;
                case "newMessage":
                case "messageRemoved":
                case "messageUpdated":
                case "addMembers":
                case "removeMembers":
                    if (evt.channelId === channel.id) {
                        channel.dispatchEvent(evt);
                    }
                    break;
                default:
            }
        });
    };
    return ChatClient;
}());
exports.default = ChatClient;
//# sourceMappingURL=chatClient.js.map